<template>
  <div class="app-main">
    <a-config-provider :locale="locale">
      <!-- <Header v-if="!$route.meta.isHidden"></Header> -->
      <router-view></router-view>
    

    <div class="minBox" ref="settingRef" :style="transformStyle">
      <div class="minContent" v-for="item in minList" :key="item" >
        <span class="min-title">{{item.title}}</span>
        <span>
          <svg @click="toMoadl(item)" t="1675991924873" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11993" width="18" height="18"><path d="M793.6 847.127273l-179.2-179.2a36.212364 36.212364 0 0 1 51.2-51.2l179.2 179.2a36.212364 36.212364 0 1 1-51.2 51.2z" fill="#A2A5B4" p-id="11994"></path><path d="M830.696727 655.825455v206.848a36.212364 36.212364 0 0 0 72.424728 0v-206.894546a36.212364 36.212364 0 0 0-72.424728 0z" fill="#A2A5B4" p-id="11995"></path><path d="M656.523636 829.998545h206.848a36.212364 36.212364 0 0 1 0 72.378182h-206.848a36.212364 36.212364 0 0 1 0-72.378182zM339.456 392.983273L193.163636 246.690909a36.212364 36.212364 0 1 1 51.2-51.2l146.292364 146.292364a36.212364 36.212364 0 0 1-51.2 51.2z" fill="#A2A5B4" p-id="11996"></path><path d="M370.874182 195.956364H164.026182a36.212364 36.212364 0 0 1 0-72.378182h206.848a36.212364 36.212364 0 0 1 0 72.378182z" fill="#A2A5B4" p-id="11997"></path><path d="M196.701091 370.176V163.281455a36.212364 36.212364 0 0 0-72.424727 0v206.894545a36.212364 36.212364 0 0 0 72.424727 0z" fill="#A2A5B4" p-id="11998"></path><path d="M847.872 233.053091l-179.2 179.2a36.212364 36.212364 0 0 1-51.2-51.2l179.2-179.2a36.212364 36.212364 0 1 1 51.2 51.2z" fill="#A2A5B4" p-id="11999"></path><path d="M656.523636 195.956364h206.848a36.212364 36.212364 0 0 0 0-72.378182h-206.848a36.212364 36.212364 0 0 0 0 72.378182z" fill="#A2A5B4" p-id="12000"></path><path d="M830.696727 370.176V163.281455a36.212364 36.212364 0 0 1 72.424728 0v206.894545a36.212364 36.212364 0 0 1-72.424728 0z" fill="#A2A5B4" p-id="12001"></path><path d="M393.681455 687.243636l-146.245819 146.245819a36.212364 36.212364 0 1 1-51.2-51.2l146.245819-146.245819a36.212364 36.212364 0 0 1 51.2 51.2z" fill="#A2A5B4" p-id="12002"></path><path d="M196.701091 655.825455v206.848a36.212364 36.212364 0 0 1-72.424727 0v-206.894546a36.212364 36.212364 0 0 1 72.424727 0z" fill="#A2A5B4" p-id="12003"></path><path d="M370.874182 829.998545H164.026182a36.212364 36.212364 0 0 0 0 72.378182h206.848a36.212364 36.212364 0 0 0 0-72.378182z" fill="#A2A5B4" p-id="12004"></path></svg>
          <svg @click="closeMin(item)"  t="1675991965229" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12141" width="18" height="18"><path d="M230.385866 742.382499m25.606007-25.606007l460.776492-460.776492q25.606008-25.606008 51.212016 0l0 0q25.606008 25.606008 0 51.212016l-460.776492 460.776491q-25.606008 25.606008-51.212016 0l0 0q-25.606008-25.606008 0-51.212015Z" fill="#A2A5B4" p-id="12142"></path><path d="M716.801278 768.02142L255.991873 307.212016a36.212364 36.212364 0 0 1 51.212016-51.212016l460.776492 460.776492a36.212364 36.212364 0 0 1-51.212016 51.212015z" fill="#A2A5B4" p-id="12143"></path></svg>
        </span>
      </div>
    </div>
    <!-- 录入/编辑弹窗 -->
    <!-- 录入客户弹窗 -->
    <addShell :isShowMoadl='addCustorm.isShow' v-if="addCustorm.isShow">
      <add-custorm :addPar='addCustorm'></add-custorm>
    </addShell>
    <!-- 录入职位弹窗 -->
    <addShell :isShowMoadl="addPosition.isShow" v-if="addPosition.isShow">
      <entry-position-com :addPar = 'addPosition'></entry-position-com>
    </addShell>
    <!-- 录入人才弹窗 -->
    <addShell :isShowMoadl="addPersonnel.isShow" v-if="addPersonnel.isShow">
      <add-personnel :addPar='addPersonnel'></add-personnel>
    </addShell>

    </a-config-provider>
  </div>
</template>

<script>
import { useRouter  } from "vue-router";
import { isEqual} from 'lodash-es'
import { message } from "ant-design-vue";
import {getCurrentInstance,defineComponent,reactive,toRefs,onUnmounted,ref,watch,watchEffect,computed, onMounted} from 'vue'
// import Header from "./components/common/header.vue";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import addShell from "@/components/shell/addShell.vue"
import EntryPositionCom from "@/views/position/entryPostionCom.vue"//录入职位
import AddCustorm from '@/views/custorm/addCustorm.vue';//录入客户
import AddPersonnel from '@/views/personnel/addPersonnel.vue'//录入简历
// import getDrag from "@/composables/drag"
import { useDraggable} from "@vueuse/core";
// import axios from "axios";
dayjs.locale('zh-cn');
export default defineComponent({
  name: 'App',
  components: {
    // Header,
    addShell,
    EntryPositionCom,
    AddCustorm,
    AddPersonnel,
  },
  setup(){
    const router = useRouter();
    const data = reactive({
      locale: zhCN,
      addCustorm:{
        isShow:false,
        fromMin:false,
        id:'',
        newID:'',
      },
      addPersonnel:{
        isShow:false,
        fromMin:false,
        id:'',
        newID:'',
      },
      addPosition:{
        isShow:false,
        fromMin:false,
        id:'',
        newID:'',
      },
      minList:[],
      allScreen:{
        width:0,
        height:0,
      },
      windowBox:'',
    }) 
    // 订阅录入/编辑弹窗打开关闭
    const $bus = getCurrentInstance().appContext.config.globalProperties.$bus
    $bus.on('changeAdd', options => {
      let list = localStorage.getItem(options.key)?JSON.parse(localStorage.getItem(options.key)):[]
      if(data[options.key].isShow && list.length ==3 ){
        message.success('您更改的内容最大化最小化已经三个,请保存后在添加');
        return
      }
      data[options.key].fromMin = false
      data[options.key].isShow = options.val
      if(options.val){
        data[options.key].id = options.id
        data[options.key].newID = options.newID
        data[options.key].customerId = options.customerId
      }
    })
    $bus.on('addMin', options => {
      data.minList.unshift(options)
      
    })

    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('addCustorm')
      localStorage.removeItem('addPersonnel')
      localStorage.removeItem('addPosition')
    })
    const setWinHeight =()=>{
      data.windowBox = window
    }
    window.addEventListener("resize", setWinHeight);
    
    onMounted(() => {
      checkVersion()
    })
    const checkVersion = () => {
      // setInterval((
      //   axios.get(`../public/json/version.json`).then((res) => { console.log('res', res); })
      // ), 6000)
    }
    onUnmounted(()=>{
      $bus.off('changeAdd')
      $bus.off('addMin')
      localStorage.removeItem('addCustorm')
      localStorage.removeItem('addPersonnel')
      localStorage.removeItem('addPosition')
      window.removeEventListener("resize", setWinHeight);
    })

    const closeMin=(options)=>{
      data.minList =  data.minList.filter(function(item){
        return !isEqual(options,item);	
      })
    }//关闭最小化窗口
    const toMoadl=(options)=>{
      data[options.path].fromMin = true
      data[options.path].isShow = true
      data[options.path].id = options.id
      data[options.path].newID = options.newID
      closeMin(options)
    }//放大最小化窗口

    //可拖拽
    const startX = ref(0);
    const startY = ref(0);
    const startedDrag = ref(false);
    const transformX = ref(0);
    const transformY = ref(0);
    const preTransformX = ref(0);
    const preTransformY = ref(0);
    const dragRect = ref({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    });
    const settingRef = ref(null)
    const {
      x,
      y,
      isDragging,
    } = useDraggable(settingRef)
    const transformStyle = computed(() => {
      return {
        transform: `translate(${transformX.value}px, ${transformY.value}px)`,
      };
    });
    watch([x, y], () => {
      data.windowBox = window
      if (!startedDrag.value) {
        startX.value = x.value;
        startY.value = y.value;
        const titleRect = settingRef.value.getBoundingClientRect();
        dragRect.value.right = data.windowBox.innerWidth - titleRect.width;
        dragRect.value.bottom = data.windowBox.innerHeight - titleRect.height;
        preTransformX.value = transformX.value;
        preTransformY.value = transformY.value;
      }
      startedDrag.value = true;
    });
    watch(isDragging, () => {
      if (!isDragging) {
        startedDrag.value = false;
      }
    });
    watchEffect(() => {
      if (startedDrag.value) {
        transformX.value = preTransformX.value + Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) - startX.value;
        transformY.value = preTransformY.value + Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) - startY.value;
        if(transformY.value > 0){
          transformY.value = 0
        }
        if(transformY.value + dragRect.value.bottom <  48){
          transformY.value = 48 - dragRect.value.bottom
        }
      }
    });
    watch(() => router.currentRoute.value.path,(to) => {
       if(to == '/login'){
        localStorage.removeItem('addCustorm')
        localStorage.removeItem('addPersonnel')
        localStorage.removeItem('addPosition')
        data.minList = []
       }
    },{ immediate: true });
    return {
      ...toRefs(data),
      toMoadl,
      closeMin,
      settingRef,
      transformStyle,
      checkVersion
    }
  }
})
</script>

<style>
@import "./assets/css/reset.less";
#app {
  font-family: "PingFang SC", "Lantinghei SC", "Open Sans", Arial,
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "STHeiti",
    "WenQuanYi Micro Hei", SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.popover-operation-wrap .ant-popover-inner-content{
  padding: 10px 0;
}
/* confirm弹窗 */
.ant-modal-confirm .ant-modal-body{
  padding: 24px 24px 20px;
}
.ant-modal-confirm .ant-modal-content{
  border-radius:4px;
}
.ant-modal-confirm-body .ant-modal-confirm-title{
  font-weight: 600;
  color: #333333;
}
.ant-modal-confirm-body .ant-modal-confirm-content{
  font-family: PingFangSC-Regular, PingFang SC;
  color: #4F5B6E;
  font-weight: 400;
}

.ant-drawer-mask{
  background: transparent;
}
</style>
<style scoped>
.minBox{
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 99;
  cursor: move;
}
.minContent{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  width: 360px;
  background: #fff;
  border-radius: 4px;
  border:1px solid #DCDFE6;
  box-shadow: 0px 0px 12px 4px rgb(0 0 0 / 0.1);
}
.minContent span ,.minContent span  svg{
  line-height: 22px;
  height: 22px;
}
.minContent span svg:hover path{
  fill: #507AFD;
}
.min-title{
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.minContent svg{
  margin-left: 8px;
  cursor: pointer;
}


</style>
